import { render, staticRenderFns } from "./NotStarted.vue?vue&type=template&id=5a571661&"
import script from "./NotStarted.vue?vue&type=script&lang=js&"
export * from "./NotStarted.vue?vue&type=script&lang=js&"
import style0 from "./NotStarted.vue?vue&type=style&index=0&id=5a571661&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports